import CommuteIcon from '@mui/icons-material/Commute'
export default {
  name: 'vehicle-groups',
  recordRepresentation: 'name',
  icon: CommuteIcon,
  options: {
    defaultSort: { field: 'name', order: 'ASC' },
    badge: true,
  },
}
